var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.confirm-email-change-page {\n  background-image: url(" + escape(require("../../assets/images/login-bg.svg")) + ");\n  background-size: cover;\n  height: 100%;\n}\n.confirm-email-change-page .v-card {\n  min-height: 180px;\n  padding-top: 36px;\n}\n.confirm-email-change-page .v-card .progress-message {\n  margin-top: 36px;\n}", ""]);

// exports
exports.locals = {
	"bodyFontFamily": "\"Roboto\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", \"Microsoft YaHei\", 微软雅黑, STXihei, 华文细黑, \"WenQuanYi Micro Hei\", 文泉驿微米黑, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
	"error": "#E74C3C"
};